// Campaign step kind — shows the fields that belong to the step's kind
// and, for an action or branch step, to the chosen action or question.
//
// Every panel renders server-side with the right one visible, so this
// only keeps them in step as the author changes the pickers. Hidden
// rather than removed: switching back keeps what was typed, and the
// save reads only the fields of the kind submitted.
//
// Targets: [data-step-kind-fields].

import { onceGuard } from "./bind_once.js";

const firstBind = onceGuard();

export function initCampaignStepKind(root = document) {
  root.querySelectorAll("[data-step-kind-fields]").forEach((form) => {
    if (!firstBind(form)) return;

    const kinds = form.querySelectorAll('input[name="step_kind"]');
    const action = form.querySelector('select[name="action_kind"]');
    const condition = form.querySelector('select[name="branch_condition"]');

    const sync = () => {
      const kind =
        form.querySelector('input[name="step_kind"]:checked')?.value ||
        "message";
      form.querySelectorAll("[data-step-kind-panel]").forEach((panel) => {
        panel.hidden = panel.dataset.stepKindPanel !== kind;
      });

      const chosen = action?.value || "";
      form.querySelectorAll("[data-action-field]").forEach((field) => {
        field.hidden = !field.dataset.actionField.split(" ").includes(chosen);
      });

      const asked = condition?.value || "";
      form.querySelectorAll("[data-branch-field]").forEach((field) => {
        field.hidden = field.dataset.branchField !== asked;
      });
    };

    kinds.forEach((input) => input.addEventListener("change", sync));
    action?.addEventListener("change", sync);
    condition?.addEventListener("change", sync);
  });
}
